<!-- M -->
<div *ngIf="isMediumSize" class="d-flex" [ngClass]="{
    'gap-2' : !this.isTableChild,
    'gap-3 justify-content-center align-items-center': this.isTableChild
}">
    <ng-container #buttonContainer></ng-container>
</div>

<!-- S -->
<div *ngIf="isSmallSize || isExtraSmall" class="position-relative">
    <!-- for 1 button -->
    <div *ngIf="(this.getMetaData().models.length === 1 && isSmallSize)">
        <ng-container #buttonContainer></ng-container>
    </div>

    <!-- when is a table button and is small size -->
    <div *ngIf="this.getTableComponentId() && this.isSmallSize" class="d-flex align-items-center gap-3 justify-content-center">
        <ng-container #buttonContainer></ng-container>
    </div>

    <!-- actions button(more than 1 button) in small screens-->
    <div *ngIf="this.getMetaData().models.length > 1 && isSmallSize && !this.isTableChild" 
        class="action-button-container th-bg-white d-flex" (click)="toggleActionWindow()">
        <!-- text section -->
        <div class="action-text d-flex justify-content-center align-items-center">
            <span class="bs-menu-lateral th-text-main">Acciones</span>
        </div>
        <!-- button section  -->
        <div class="action-button d-flex justify-content-center align-items-center"
             [ngClass]="{
                'action-button-selected-color ' : isWindowOpen
             }">
            <i class="fa fa-ellipsis-v" aria-hidden="true" *ngIf="!isWindowOpen"></i>
            <i class="fa fa-times" aria-hidden="true" *ngIf="isWindowOpen"></i>
        </div>
    </div>

    <!-- actions button(more than 1 button) in extra small screens-->
    <div *ngIf="isExtraSmall" (click)="toggleActionWindow()" class="btn-action-icon-container "[ngClass]="{
        'd-flex justify-content-center' : this.isTableChild,
        'th-bg-main' : this.getCollapsedColor() === this.ContainerColors.Primary,
        'th-bg-secondary' :this.getCollapsedColor() === this.ContainerColors.Secondary,
        'th-bg-alert' : this.getCollapsedColor() === this.ContainerColors.Danger,
        'th-bg-confirmation' : this.getCollapsedColor() === this.ContainerColors.Success,
        'th-bg-white': this.getCollapsedColor() === this.ContainerColors.White,
        'th-bg-dark-gray': this.getCollapsedColor() === this.ContainerColors.Neutral
    }">
        <i [ngClass]="{
            '' : this.getCollapsedColor() === this.ContainerColors.Default || this.getCollapsedIcon() === '',
            'collapsed-icon-color': this.getCollapsedColor()!== this.ContainerColors.Default && this.getCollapsedColor() !==''
        }"
         [class]="this.getCollapsedIcon() === null || this.getCollapsedIcon() === '' ? 'fa fa-ellipsis-h' : this.getCollapsedIcon()" aria-hidden="true"></i>
    </div>

    <!-- window of action button -->
    <div class="action-window th-bg-white" *ngIf="isWindowOpen"
         [ngClass]="{
            'action-window-xs' : isExtraSmall && !this.isTableChild,
            'action-window-xs-table-child' : isExtraSmall && this.isTableChild,
            'w-100' : isSmallSize
         }">

        <div *ngIf="isExtraSmall" class="title">
            <span class="bs-menu-lateral th-text-main">Acciones</span>
        </div>
        <div *ngFor="let button of windowActionButtons; let i=index" (click)="executeButtonAction(i)" [class.d-none]="!button.isVisible">
            <div class="content d-flex">                 
                <div>
                    <span class="bs-paragraph th-text-gray-paragraphs">{{button.name}}</span>
                </div>
                <div class="ms-auto">
                    <i [class]="button.icon" aria-hidden="true" [ngClass]="{
                        'th-text-main' : button.color.toUpperCase() !== 'DANGER' || button.color.toUpperCase() !== 'DANGERBUTTONCONTAINER',
                        'th-text-alert' : button.color.toUpperCase() === 'DANGER' || button.color.toUpperCase() === 'DANGERBUTTONCONTAINER'
                    }"></i>
                </div>
            </div>
            <div class="line action-button-selected-color  w-100"></div>
        </div>
    </div>
</div>